import http from "./http";
import type { SkillsType } from '../models/competencias_model';

export const getSkills = async () => {
  try {
    return await http.get<SkillsType>(`/kinder/competencia`);
  } catch (error) {
    console.error("[get_skills]  Error -> ", error);
    return null;
  }
};

export const saveKinderSkills = async (data: SkillsType) => {
  try {
    return await http.post<SkillsType, SkillsType>(`/kinder/competencia`, data);
  } catch (error) {
    console.error("[save_kinder_skills]  Error -> ", error);
    return null;
  }
};